import { object, string } from 'yup';
import i18n from '../../../i18n';

// Types
import { AnimalManagement } from './types';

export const AnimalManagementSchema = object<AnimalManagement>({
  name: string().required(() => i18n.t('validation:required')),
});
